import { Checkbox, TableCell } from '~/UIKit';
import React from 'react';
import { CellProps } from './CellProps';
import { makeStyles } from '~/UIKit/Style';

/**
 * TODO: Find a way to handle selection inside the table
 */
export interface CheckBoxCellProps extends CellProps {
  handleCheckedChange: (value: any) => void;
  checked: boolean;
  value: any;
}

const useStyles = makeStyles(() => ({
  cell: {
    paddingLeft: 0,
  },
}));

const CheckBoxCell = ({ value, handleCheckedChange, checked, className }: CheckBoxCellProps) => {
  const { classes } = useStyles();

  return (
    <TableCell align="left" className={`${classes.cell} ${className}`}>
      <Checkbox checked={checked} color="primary" onChange={() => handleCheckedChange(value)} />
    </TableCell>
  );
};

export default CheckBoxCell;
